import DeviceDetection from 'oc-commons/DeviceDetection.js';
import {v3} from "./short3.js";
import Maths3 from "oc-threejs/Maths3";

export default {
    renderer: {
        //Set true to export transparent png
        antialias: true,
        alpha: true,
        clearColor: {
            color: 0xEEEEEE,
            alpha: 1
        },
        sortObjects: true,
        toneMapping: "LinearToneMapping",
        pbrPipeline: true,
        // @deprecated
        deactivatePhysicalLights: false,
        exposure: 1,
        usePbrMap: true,
        logarithmicDepthBuffer: false
    },
    ratioFactor: 1,
    showFramesPerSecondInfo: false,
    showBoundingBoxRuler: true,
    showDebugObjects: false,
    showDebugNotANumberInSceneError: true,
    showGroundPlane: false,

    raycaster: {
        // welchen Raycast-Radius hat eine Linie? Ist leider ein globales Property in ThreeJS, wäre besser eine
        // Eigenschaft der Linie
        linePrecision: 0.01,
    },

    dragDrop: {
        clickMsTreshold: 600,
        clickPxTreshold: 12,
        cursorChangesOverDraggables: true,
        radiusSnapStart: 0.2,
        radiusSnapEnd: 0.6,
        radiusSnapStep: 0.1,
        restraintsDebugColor: 0x707070,
        snapsDebugColor: 0xffffff,
        dragOpacity: 0.8
    },

    ruler: {
        scale: 1.0,
        fixed: 2,
        unit: 'm',
        mInUnit: 1.0,
    },

    lowPerformanceDevice: DeviceDetection.isLowPerformanceDevice(),
    "ar":{
        "possible":false,
        "autoStartInApp":true,
        "hiddenObjectNames":[],
        "debug":false
    },
    "camera": {
        "fov": 45,
        "near": 0.01,
        "far": 10000,
        "initialZoomFaktor": 1,
        "zoomSpeed": 1.0,
        "rotateSpeed": 1.0,
        "enableDamping":false,
        "dampingFactor":0.25,
        "target": {
            "x": 0,
            "y": 0,
            "z": 0
        },
        "position": {
            "x": 0,
            "y": 1.8,
            "z": 10
        },
        "disablePan": false,
        "bindToYPlaneWithHeight": false,
        "distance": {
            "min": 0.01,
            "max": 10000
        },
        // in deg 0<=min<=max<=180
        "polarAngle": {
            "min": 0,
            "max": 180,
            "locked": false
        },
        //auch in deg, blockiert nicht bei Werten ausserhalb von [-180,180]
        "azimuthAngle": {
            "min": -Infinity,
            "max": Infinity
        },
        "minCameraTargetPosition": {
            "x": -Infinity,
            "y": -Infinity,
            "z": -Infinity
        },
        "maxCameraTargetPosition": {
            "x": Infinity,
            "y": Infinity,
            "z": Infinity
        },
        "minCameraPosition": {
            "x": -Infinity,
            "y": -Infinity,
            "z": -Infinity
        },
        "maxCameraPosition": {
            "x": Infinity,
            "y": Infinity,
            "z": Infinity
        }
    },

    connectors: {
        size: 0.1,
        anchorPlane: Maths3.plane.y0.clone(),
        anchorsAreGroundedDistance: 0.1,
        distanceWhereForceIs0: 3,
        distanceWhereForceIs1: 0.2,
        distanceWhereForcePulseIs0: 5,
        distanceWhereForcePulseIs1: 0.5,
        PulseFactor: 50,
        PulseGroudLine: 0.4,
        openingAngle: 270,
        openingAngleForce: 0,
        openingAngleWhereForceIs1: 90,
        forceShuffleSteps: 1,
        snapDistance: 0.5,

        markers: {
            alpha: 308,
            speed: 0.5,
            ab: 0.22,
            tori: 2,
            radius: 0.1,
            tube: 0.02,
            radialSegments: 3,
            tubularSegments: 16,
        },

        box: {
            animate: true,
            minDistanceTreshold: 0.3,
        }
    },

    shadows: {
        enabled: true,
    },

    printDesigner: {
        hideControls: false,
        font: {
            scale: 2.0,
            color: "#000000"
        },

        qualityThreshold: {
            lowDPI: 75,
            highDPI: 150
        }
    },

    saoPass:{
        saoBias: -0.68,
        saoIntensity: 0.0005,
        saoScale: 12, //6
        saoKernelRadius: 39,
        saoMinResolution: 0,
        saoBlur: true,
        saoBlurRadius: 8, //6
        saoBlurStdDev: 3, //2
        saoBlurDepthCutoff: 0.002
    },

    rendererBackgroundImage: false,

    lightSettingsName: 'default',
};
